import repo from 'service/repository';
import { errorHandingWithCode } from 'helpers/error-handler';
import { useHistory } from 'react-router-dom';
import {
  useAppContext,
  SHOW_APP_MESSAGE,
  SHOW_TOAST_MESSAGE,
  REFUELING_REQUEST,
  TOGGLE_REFUELING_PROCESSING_DIALOG,
} from 'use-app';
import { PATH } from 'config';

export const useRefuelingRequest = () => {
  const { dispatch: appDispatch } = useAppContext();
  const history = useHistory();

  const rejectRefuelingRequest = id => {
    repo
      .answerRefuelingRequests(id, 'reject')
      .then(() => {
        appDispatch({
          type: SHOW_TOAST_MESSAGE,
          payload: '此筆授權交易已取消成功',
        });
      })
      .catch(error => errorHandingWithCode(error))
      .finally(() => {
        appDispatch({
          type: REFUELING_REQUEST,
          payload: null,
        });
        appDispatch({
          type: TOGGLE_REFUELING_PROCESSING_DIALOG,
          payload: false,
        });
      });
  };

  const acceptRefuelingRequest = id => {
    appDispatch({
      type: TOGGLE_REFUELING_PROCESSING_DIALOG,
      payload: true,
    });
    repo
      .answerRefuelingRequests(id, 'accept')
      .then(value => {
        if (value.state === 'accepted' && value.paymentState === 'paid') {
          appDispatch({
            type: SHOW_APP_MESSAGE,
            payload: {
              type: 'success',
              message: '加油付款成功！別忘了下次也要用麻吉付喔～',
            },
          });
        } else if (value.state === 'rejected' && value.paymentState === 'unpaid') {
          appDispatch({
            type: SHOW_APP_MESSAGE,
            payload: {
              type: 'failure',
              message: '此筆授權交易已取消成功',
            },
          });
        } else {
          appDispatch({
            type: SHOW_APP_MESSAGE,
            payload: {
              type: 'failure',
              message: '付款失敗，請確認付款資訊是否有效或洽詢客服',
            },
          });
        }
        history.push(`${PATH.ORDER_DETAIL}?url=${value.refuelingOrderUrl}`);
      })
      .catch(error => {
        console.log(errorHandingWithCode(error));
        appDispatch({
          type: SHOW_APP_MESSAGE,
          payload: {
            type: 'failure',
            message: '付款失敗，請確認付款資訊是否有效或洽詢客服',
          },
        });
      })
      .finally(() => {
        appDispatch({
          type: TOGGLE_REFUELING_PROCESSING_DIALOG,
          payload: false,
        });
        appDispatch({
          type: REFUELING_REQUEST,
          payload: null,
        });
      });
  };

  const refuelingRequestTimeout = () => {
    appDispatch({
      type: SHOW_TOAST_MESSAGE,
      payload: '授權時間已逾時，請重新再試。',
    });
    appDispatch({
      type: REFUELING_REQUEST,
      payload: undefined,
    });
  };
  return { rejectRefuelingRequest, acceptRefuelingRequest, refuelingRequestTimeout };
};
